import type { UnauthApi } from '@/api';

import type { getWeeklyTop } from './WeeklyTopSectionServer';

type WeeklyTopQuery = NonNullable<
  NonNullable<
    Parameters<
      (typeof UnauthApi)['get:/wello/v2/allows/home/gift-product/weekly-top']
    >[0]
  >['query']
>;

export type WeeklyTopGroupCode = NonNullable<
  WeeklyTopQuery['giftCategoryGroupType']
>;

export const WEEKLY_TOP_SIZE = 10;
export const WEEKLY_TOP_ROWS_PER_COLUMN = 5;
export const WEEKLY_TOP_ALL_GROUP_CODE: WeeklyTopGroupCode = 'ALL';

type WeeklyTop = NonNullable<Awaited<ReturnType<typeof getWeeklyTop>>>;

export type WeeklyTopItem = WeeklyTop['contents'][number];
export type WeeklyTopGroup = WeeklyTop['groups'][number];
